import {
  Leaf,
  Sprout,
  Droplets,
  Zap,
  Scissors,
  Bug,
  Shield,
  Calendar,
  MapPin,
  Wrench,
  HelpCircle,
  type LucideIcon,
} from "lucide-react"

// Category -> media-tile fallback icon, used by the glass blog card when a post
// has no image. Mirrors the Claude Design prototype's BLOG_CATS icon mapping;
// the accent color comes from getCategoryColor() in lib/category-utils.
const CATEGORY_ICONS: Record<string, LucideIcon> = {
  "Grass Types": Leaf,
  "Lawn Care Tips": Sprout,
  Watering: Droplets,
  Fertilizing: Zap,
  "Mowing & Maintenance": Scissors,
  "Pest Control": Bug,
  "Weed Control": Shield,
  "Seasonal Care": Calendar,
  "Seeding/Overseeding & Establishment": Sprout,
  "Climate & Regional Tips": MapPin,
  "Tech & Tools": Wrench,
  "Problem Solving": HelpCircle,
}

export function getCategoryIcon(category: string): LucideIcon {
  return CATEGORY_ICONS[category] ?? Leaf
}
